export enum TractorType {
  TRACTOR = "TRACTOR",
  ATV_REGISTERED_AS_TRACTOR = "ATV_REGISTERED_AS_TRACTOR",
}
